import usePermissions from "@/hooks/use-permissions.hook.ts";
import { useJobEditSteps } from "@/pages/recruit/jobs/edit/components/job-edit.type.ts";
import { JobEditStep } from "@/pages/recruit/jobs/edit/job-edit.types.ts";
import { ApiJob } from "@/types/recruit/job.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";
import { LinkTo, Stack, Text } from "@skailer-com/uikit";

interface Props {
  step: JobEditStep;
  job?: ApiJob;
}
export const JobEditSidebar = ({ step, job }: Props) => {
  const stepTitleMap = useJobEditSteps();
  const { isFeatureEnabled } = usePermissions();

  const steps = [
    JobEditStep.details,
    ...(isFeatureEnabled(ApiFeatureType.ats_career_site) ? [JobEditStep.career] : []),
  ];

  return (
    <Stack className={"px-6"} gap={"md"}>
      {steps.map((item) => {
        const className = step === item ? "text-default" : "text-secondary";

        if (!job) {
          return (
            <Text key={item} className={className}>
              {stepTitleMap[item]}
            </Text>
          );
        }

        return (
          <LinkTo
            key={item}
            to={`/recruitment/jobs/${job.id}/edit/${item}`}
            variant={"plain"}
            className={className}
          >
            <Text>{stepTitleMap[item]}</Text>
          </LinkTo>
        );
      })}
    </Stack>
  );
};
